module.exports = __webpack_public_path__ + "static/img/home005.c50bfd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/home005.png
// module id = +hD7
// module chunks = 0